<template>
  <div class="common-wrap">
    <h1 class="logo">
      <img :src="logoImg" />
    </h1>
    <div class="regist-box-wrap">
      <div class="box-item" @click="onRegisterPageJump('personal')">
        <img src="@/assets/img/img_geren@2x.png" class="box-item-img" />
        <div class="role-wrap">
          <div class="text-wrap">
            <p class="text-title">我是个人</p>
            <p class="text-subhead">I am a person</p>
          </div>
          <img src="@/assets/img/icon_gengduo01@2x.png" class="role-img" />
        </div>
      </div>
      <div class="box-item company" @click="onRegisterPageJump('company')">
        <img src="@/assets/img/img_qiye@2x.png" class="box-item-img" />
        <div class="role-wrap">
          <div class="text-wrap">
            <p class="text-title">我是企业</p>
            <p class="text-subhead">I am a company</p>
          </div>
          <img src="@/assets/img/icon_gengduo01@2x.png" class="role-img" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ssoService, SSO_CONFIG } from "@/plugins/ajx-common";
export default {
  data() {
    return {
      logoImg: require("@/assets/img/img_logo@2x.png"),
    };
  },
  methods: {
    // 注册页面跳转
    onRegisterPageJump(type) {
      console.log("注册页面跳转----", type);
      if (type === "personal") {
        // 跳转到个人注册页
        ssoService.redirect(SSO_CONFIG.FrontProject.CUSTOMER_SYSTEM, {
          replace: true,
          redirect: "#/login",
          // 是否拼接域名
          needDomain: true,
        });
      } else {
        // 跳转到企业注册页
        ssoService.redirect(SSO_CONFIG.FrontProject.ENT, {
          replace: true,
          redirect: "#/register",
          // 是否拼接域名
          needDomain: true,
        });
      }
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.common-wrap {
  .regist-box-wrap {
    display: flex;
    justify-content: center;
    padding-top: 230px;
    padding-bottom: 40px;
    .box-item {
      width: 544px;
      height: 408px;
      background-image: url("@/assets/img/bg_img_geren@2x.png");
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:hover {
        cursor: pointer;
        border-radius: 15px;
        box-shadow: 3px 3px 10px 0px rgba(0, 0, 0, 0.75);
      }
      .box-item-img {
        width: 250px;
        height: 214px;
      }
      .role-wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .text-wrap {
          font-family: Microsoft YaHei, Microsoft YaHei;
          .text-title {
            font-weight: bold;
            font-size: 28px;
            color: #333333;
            line-height: 33px;
          }
          .text-subhead {
            font-weight: 400;
            font-size: 12px;
            color: #f66717;
            line-height: 14px;
            margin-top: 16px;
          }
        }
        .role-img {
          width: 20px;
          height: 20px;
          margin-left: 16px;
        }
      }
    }
    .company {
      background-image: url("@/assets/img/bg_img_geren@2x(1).png");
      margin-left: 40px;
    }
  }
}
</style>
